import React from 'react';
import { ReactComponent as Past } from '../img/icons/past.svg';
import { ReactComponent as Now } from '../img/icons/now.svg';
import { ReactComponent as Future } from '../img/icons/future.svg';

const About = () => {
	return (
		<>
			<section className="about">
				<div className="about_wrapper">
					<div className="about_heading">
						<h2>A Little About Me</h2>
					</div>
					<div className="about_grid">
						<div className="about_grid__card">
							<Past height={50} width={50} />
							<h3>Past</h3>
							<p>
								My journey into web development started in 2018.
								At the time I was working a job that I didn’t
								feel was for me, and I needed a change. After
								trying several different things, I started the
								process of learning to code. It didn’t take long
								for me to get hooked, and was really enjoying
								what I was doing. I tried many different
								languages early on, but settled on JavaScript,
								React, and NodeJS. After a few years I was able
								to land my first job as a front-end developer in
								2021.
							</p>
						</div>
						<div className="about_grid__card">
							<Now height={50} width={50} />
							<h3>Present</h3>
							<p>
								Currently, I am working that job and enjoy what
								I do. After starting with the company I have
								grown massively in skill, and still really enjoy
								coding. I started out as not knowing much, and
								now I have been tasked to lead the front-end
								development of our larger projects. My current
								work tech stack is WordPress, PHP, and SQL. Most
								of my personal or at home projects I build in
								React, TypeScript, Redux Toolkit, SASS, and
								either MongoDB or SQL.
							</p>
						</div>
						<div className="about_grid__card">
							<Future height={50} width={50} />
							<h3>Future</h3>
							<p>
								Looking ahead to where I see myself in the
								future, I want to become a full stack developer.
								I have built small APIs for my personal
								projects, and have started to learn C#. I know
								there is still a large amount of ground I need
								to cover to get to this goal, but the best part
								of coding is the learning process. Looking to
								find new ways to do something, different ways to
								build something, or just the enjoyment of
								solving a problem I have around the house. These
								are the reasons I do what I do, and why I want
								to continue this journey.
							</p>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default About;
